import { useState } from "react";
import {
  AutoComplete,
} from "antd";

import { util } from '@seims/shared';
import qgramInstit from "../../data/institutions-qgram-inverted-index.json";

const InstitutionPicker = ({
  width = "800px",
  value,
  placeholder = "Start typing to options",
  name,
  key,
  onSelectedInstitution,
}) => {
  const [options, setOptions] = useState([]);

  const onSearched = async (query) => {
    const locationOptions = util.findLocation(query, qgramInstit);
    const optionsX = renderOptions(locationOptions);
    setOptions(optionsX);
  };
  const onSelected = (value) => {
    onSelectedInstitution(value);
  };

  const renderItem = (title, count) => ({
    value: title,
    label: (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {title}
      </div>
    ),
  });

  const renderOptions = (data) => {
    if (data) return data.map((item) => renderItem(item.document));
    return "";
  };

  return (
    <AutoComplete
      dropdownMatchSelectWidth={width}
      key={key}
      name={name}
      style={{ width: width }}
      onSelect={onSelected}
      value={value}
      onChange={onSelected}
      onSearch={onSearched}
      options={options}
      placeholder={placeholder}
      allowClear
      filterOption={(inputValue, option) =>
        option?.value?.toLowerCase().includes(inputValue.toLowerCase())
      }
    ></AutoComplete>
  );
};

export default InstitutionPicker;
